var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"items-box"},_vm._l((_vm.videos),function(video){return _c('div',{key:video.id.videoId,staticClass:"card mb-2"},[_c('VideoListItem',{attrs:{"video":video}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }